import { useCallback } from 'react';

const HEIGHT_VAR = '--top-banner-h';

// A fixed banner can't push the layout down, so consumers read --top-banner-h
// from <html> instead of guessing how many lines the banner wrapped to.
export default function useTopBannerHeight() {
  return useCallback(node => {
    if (!node) return undefined;

    const root = document.documentElement;
    const sync = () => root.style.setProperty(HEIGHT_VAR, `${node.offsetHeight}px`);

    sync();
    const observer = new ResizeObserver(sync);
    observer.observe(node);

    return () => {
      observer.disconnect();
      root.style.removeProperty(HEIGHT_VAR);
    };
  }, []);
}
